"use strict";
/**
 * The rules of a relation pair that the browser and the server share: how a
 * relation column is named and what a duplicated relation consists of.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRelationColumnNameAvailable = isRelationColumnNameAvailable;
exports.availableRelationColumnName = availableRelationColumnName;
exports.planRelationColumnDuplicate = planRelationColumnDuplicate;
/** Name used when the database that names the column has no title. */
const FALLBACK_RELATION_COLUMN_NAME = 'Relation';
/**
 * Two column names are the same when they differ only in case or surrounding
 * spaces: a menu or an agent could not tell them apart.
 */
function relationColumnNameKey(name) {
    return name.trim().toLowerCase();
}
/** A name the user typed for a new relation column is not empty and free. */
function isRelationColumnNameAvailable(name, existingColumnNames) {
    const key = relationColumnNameKey(name);
    return (key !== '' &&
        !existingColumnNames.some(existing => relationColumnNameKey(existing) === key));
}
/**
 * The wished name while it is free, otherwise the wished name with " 2",
 * " 3" and so on.
 */
function availableRelationColumnName(desiredName, existingColumnNames) {
    const baseName = desiredName.trim() || FALLBACK_RELATION_COLUMN_NAME;
    if (isRelationColumnNameAvailable(baseName, existingColumnNames))
        return baseName;
    let suffix = 2;
    while (!isRelationColumnNameAvailable(`${baseName} ${suffix}`, existingColumnNames))
        suffix += 1;
    return `${baseName} ${suffix}`;
}
function relationCardinality(value) {
    return value === 'one' ? 'one' : 'many';
}
/**
 * What duplicating a relation column creates. A relation with a backlink is
 * a pair, so its copy is a pair as well: the copy and a new backlink in the
 * same target database. The copy must not keep the original's backlink, or
 * two columns would claim one backlink. Links between rows are never copied:
 * a second set would show the same row pairs twice on the target side.
 */
function planRelationColumnDuplicate(data) {
    const targetDatabaseId = typeof data.targetDatabaseId === 'string' ? data.targetDatabaseId : '';
    if (!targetDatabaseId || typeof data.inverseFieldId !== 'string')
        return { kind: 'single' };
    const { inverseFieldId: _originalBacklink, ...copyData } = data;
    return {
        kind: 'pair',
        copyData,
        targetDocId: typeof data.targetDocId === 'string' && data.targetDocId
            ? data.targetDocId
            : undefined,
        targetDatabaseId,
        cardinality: relationCardinality(data.cardinality),
        inverseCardinality: relationCardinality(data.inverseCardinality),
    };
}
